const companyKeys = {
    SET_COMPANY: "SET_COMPANY"
};

export default companyKeys;